import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { CalendarGrid } from './CalendarGrid';
import { CalendarNavigation } from './CalendarNavigation';
import css from './Calendar.module.css';

/**
 * Main Calendar component for displaying weekly booking view
 */
const Calendar = props => {
  const {
    events = [],
    availability = [],
    exceptions = [],
    currentWeek = new Date(),
    onWeekChange,
    onEventClick,
    className,
    rootClassName,
  } = props;

  const classes = rootClassName || css.root;
  const calendarClasses = className || css.calendar;

  return (
    <div className={classes}>
      <div className={css.header}>
        <h2 className={css.title}>
          <FormattedMessage id="Calendar.title" defaultMessage="Weekly Schedule" />
        </h2>
        <CalendarNavigation
          currentWeek={currentWeek}
          onWeekChange={onWeekChange}
        />
      </div>

      <div className={calendarClasses}>
        <CalendarGrid
          events={events}
          availability={availability}
          exceptions={exceptions}
          currentWeek={currentWeek}
          onEventClick={onEventClick}
        />
      </div>

      <div className={css.legend} data-testid="Calendar.legend">
        <div className={css.legendItem}>
          <span className={`${css.legendSwatch} ${css.legendSwatchAvailable}`} aria-hidden="true" />
          <FormattedMessage id="Calendar.legend.available" />
        </div>
        <div className={css.legendItem}>
          <span className={`${css.legendSwatch} ${css.legendSwatchUnavailable}`} aria-hidden="true" />
          <FormattedMessage id="Calendar.legend.unavailable" />
        </div>
      </div>
    </div>
  );
};

export default Calendar; 